import { useEffect } from 'react';
import { useStore } from 'react-redux';

/**
 * Dynamically injects a reducer
 */

export default ({ key, reducer }) =>
  (WrappedComponent) =>
  (props) => {
    const store: any = useStore();
    useEffect(() => {
      store.injectReducer(key, reducer);
      // could clean things up here
    }, []);
    return <WrappedComponent {...props} />;
  };
